module.exports = __webpack_public_path__ + "img/profession3.e2cdc541.png";